import * as React from 'react'
import { ReactElement } from 'react'
import ListTextField from '../../../components/TextField/List/ListTextField'
import { useFormikContext } from 'formik'
import MoneyText from '../../Text/Currency/MoneyText'
import { multiplyRate } from '../../../helpers/numberHelper'
import { TravelMutationDto, TravelOverviewDto } from '../../../config/registrationConfig'
import ModifyRegistrationRow, {
    ModifyRegistrationColumnProps,
    ModifyRegistrationColumns,
    ModifyRegistrationRowProps,
} from '../Registration/ModifyRegistrationRow'
import { TravelListProps } from './TravelList'

type Props = ModifyRegistrationRowProps<TravelOverviewDto, TravelMutationDto, TravelListProps>
type ColumnProps = ModifyRegistrationColumnProps<TravelListProps>

function Columns(props: ColumnProps): ReactElement {
    const { errors, values, handleChange } = useFormikContext<TravelMutationDto>()

    switch (props.column.key) {
        case 'distance':
            return (
                <ListTextField
                    value={values.distance}
                    suffix="km"
                    onChange={handleChange('distance')}
                    isHeader={props.column.isRowHeader}
                    errorMessage={errors?.distance?.toString()}
                />
            )
        case 'subtotal':
            return (
                <MoneyText
                    value={multiplyRate(values.distance, { amount: values.rate, currency: props.file.currency })}
                />
            )
    }
    return <ModifyRegistrationColumns<TravelMutationDto, TravelListProps> {...props} />
}

export default function ModifyTravelRow(props: Props): ReactElement {
    return <ModifyRegistrationRow<TravelOverviewDto, TravelMutationDto, TravelListProps> {...props} columns={Columns} />
}
